// TODO: rename to "TableMenu" and couple to Tables
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { IconButton, makeStyles, Menu } from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => {
  return {
    menu: {
      width: 256, // Note: this is arbitrary
      maxWidth: '100%',
    },
  };
});

// NOTE: This throws a "findDOMNode is deprecated in StrictMode" error when the 'menu' component is clicked.
// This seems to be a Martial-UI issue that happens even in their 'simple' example (https://material-ui.com/components/menus/#simple-menu)
// when you run their code in CodePen and enable React.StrictMode.
const ActionMenu = ({
  children,
  ariaControls,
  anchorProps,
  menuProps: { id: menuId, ...menuProps },
  ...props
}) => {
  const classes = useStyles();
  const moreRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const { icon: Icon = MoreVert } = props;

  // TODO: replace Math.random() with a better approach to a unique identifier
  const ariaControlsId = ariaControls || menuId || Math.random();

  // extend 'onclick' method of child (if it exists) to include logic to 'close' menu.
  const extendChildren = (children) => {
    const extendChild = (child, index = 0) => {
      const childOnClick = child.props.onClick;
      return React.cloneElement(child, {
        key: index,
        onClick: () => {
          childOnClick && childOnClick();
          handleMenuClose();
        },
      });
    };

    // If only one child exists, children is a single child object. If more than one child exists, children is an array of child objects.
    return children.length > 1
      ? children.map(extendChild)
      : extendChild(children);
  };

  const extendedChildren = children && extendChildren(children);

  return (
    <React.Fragment {...props}>
      <IconButton
        onClick={handleMenuOpen}
        ref={moreRef}
        aria-haspopup="true"
        aria-controls={ariaControlsId}
        aria-label="additional actions"
        {...anchorProps}
      >
        <Icon />
      </IconButton>
      <Menu
        id={ariaControlsId}
        keepMounted
        anchorEl={moreRef.current}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{ className: classes.menu }}
        getContentAnchorEl={null}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        {...menuProps}
      >
        {extendedChildren}
      </Menu>
    </React.Fragment>
  );
};

ActionMenu.propTypes = {
  /**
   * Props applied to the anchor element.
   */
  anchorProps: PropTypes.object,
  /**
   * If this is provided, it will override the value of `menuProps.id` in order to prioritize accessibility.
   */
  ariaControls: PropTypes.string,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Element placed after the children.
   */
  icon: PropTypes.node,
  /**
   * Props applied to the `Menu` element.
   */
  menuProps: PropTypes.object,
};

ActionMenu.defaultProps = {
  menuProps: {},
};

export default ActionMenu;
